export default {"src":"/_next/static/media/american-express.fe8f39bd.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};